import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Observable, map, of, tap } from 'rxjs';
import { ImpressumGQL} from 'src/generated/graphql';
import { completeData } from '@app/_helpers/apollo';

@Component({
    selector: 'app-impressum',
    templateUrl: './impressum.component.html',
    styleUrls: ['./impressum.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ImpressumComponent implements OnInit {

  impressum$: Observable<any> = of();
  constructor(private impressumGql: ImpressumGQL) { }

  ngOnInit(): void {
    this.impressum$ = this.impressumGql.watch().valueChanges.pipe(
      completeData(),
      map(response => {
        return (response.data.impressum)
      })
    )
  }

}